// src/common/components/importFileUpload/hooks/useImportFileUpload.ts
import { useState, useRef, ChangeEvent } from 'react'

type UseImportFileUploadProps = {
  file: File | null
  setFile: (file: File | null) => void
  extensions?: string[]
  maxCount?: number
}

export const useImportFileUpload = ({
  file,
  setFile,
  extensions = ['json'],
  maxCount = 1,
}: UseImportFileUploadProps) => {
  const [drag, setDrag] = useState(false)
  const [error, setError] = useState<string>('')
  const inputRef = useRef<HTMLInputElement>(null)

  const validateFile = (file: File): boolean => {
    const ext = file.name.split('.').pop()?.toLowerCase()
    if (!ext || !extensions.includes(ext)) {
      setError(`Неверный формат. Разрешены: ${extensions.join(', ')}`)
      return false
    }
    setError('')
    return true
  }

  const handleFile = (selectedFile: File) => {
    if (file && maxCount === 1) {
      setError('Можно загрузить только один файл')
      return
    }
    if (validateFile(selectedFile)) {
      setFile(selectedFile)
    }
  }

  const onDropHandler = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    setDrag(false)
    const droppedFile = e.dataTransfer.files[0]
    if (droppedFile) handleFile(droppedFile)
  }

  const selectFiles = (e: ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0]
    if (selected) handleFile(selected)
    if (inputRef.current) inputRef.current.value = ''
  }

  const removeFile = () => {
    setFile(null)
    setError('')
  }

  const dragStartHandler = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    setDrag(true)
  }

  const dragLeaveHandler = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    setDrag(false)
  }

  const dragOverHandler = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    setDrag(true)
  }

  return {
    drag,
    error,
    inputRef,
    onDropHandler,
    selectFiles,
    removeFile,
    dragStartHandler,
    dragLeaveHandler,
    dragOverHandler,
  }
}
